// extracted by mini-css-extract-plugin
module.exports = {"infoPage":"InfoPage_infoPage__2ekjC","headerContainer":"InfoPage_headerContainer__6rIeW","contentContainer":"InfoPage_contentContainer__2apmL","content":"InfoPage_content__30mHa"};